import { render, staticRenderFns } from "./TecInfo.vue?vue&type=template&id=33aca002&"
import script from "./TecInfo.vue?vue&type=script&lang=js&"
export * from "./TecInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports